import { useTranslation } from 'react-i18next'
import { FC } from 'react'

import { Modal, FlexRow, Button, Text } from '@/ui'

import { AlertType, ModalWrapper, Message, ConfirmButton } from './Styles'
import { ReactComponent as WarningIcon } from '@/assets/images/icons/toastsAlerts/Warning icon.svg'
import { ReactComponent as InfoIcon } from '@/assets/images/icons/toastsAlerts/Info Icon.svg'
import { ReactComponent as SuccessIcon } from '@/assets/images/icons/toastsAlerts/Success icon.svg'
import { ReactComponent as AlertIcon } from '@/assets/images/icons/toastsAlerts/Alert icon.svg'

const icons = {
  warning: WarningIcon,
  info: InfoIcon,
  success: SuccessIcon,
  error: AlertIcon,
}

interface AlertProps {
  AcceptButton?: FC
  type: AlertType
  title?: string
  message?: string
  cancelText?: string
  submitText?: string
  hideCancelButton?: boolean
  onCancel: () => void
  onSubmit: () => void
}

const Alert = ({
  AcceptButton,
  type,
  title,
  message,
  cancelText,
  submitText,
  hideCancelButton,
  onCancel,
  onSubmit,
}: AlertProps) => {
  const { t } = useTranslation()

  const Icon = icons[type]

  return (
    <ModalWrapper className="alert" onClose={onCancel} type={type}>
      <Modal.Content>
        <Icon
          style={{
            position: 'absolute',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        <div>
          {title && <Text.H1>{title}</Text.H1>}
          {message && <Message>{message}</Message>}
        </div>

        <FlexRow
          noMargin
          alignItems="flex-end"
          justifyContent={
            (onSubmit || AcceptButton) && !hideCancelButton
              ? 'space-between'
              : 'flex-end'
          }>
          {!hideCancelButton && (
            <Button.Cancel
              content={cancelText || t('Cancel')}
              onClick={onCancel}
            />
          )}
          {AcceptButton && <AcceptButton />}
          {onSubmit && (
            <ConfirmButton
              type={type}
              content={submitText || t('Ok')}
              onClick={onSubmit}
            />
          )}
        </FlexRow>
      </Modal.Content>
    </ModalWrapper>
  )
}

export default Alert
